<template>
  <div id="app" :class="{'lstheme': theme}">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      theme: false
    }
  },
  created () {
    if (this.$route.query.theme !== undefined && this.$route.query.theme === 'ls') {
      this.theme = true
    } else {
      this.theme = false
    }
  }
}
</script>

<style>
body,html{
  width: 100%;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  background: #f1f1f1;
  font-size: 14px;
  box-sizing: border-box;
  height: 100%;
}
.el-message-box{
  width: 80%;
}
.el-button--primary{
  border-color: #a11b00!important;
  background: #a11b00!important;
}
#app.lstheme {
  background: url('assets/images/lsbg.jpg') no-repeat;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue